import React from "react";
import { Link } from "react-router-dom"; // Import Link from React Router
import { FaInstagram, FaTiktok, FaLinkedin, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-gray-600 mt-20 p-10 md:p-20">
      <div className="flex flex-col items-center space-y-8 text-center md:text-left md:flex-row md:justify-between md:items-start">
        {/* Branding */}
        <div className="flex flex-col items-center md:items-start">
          <h2 className="text-3xl font-bold mb-2 text-custom-red">Minglee</h2>
          <div className="flex space-x-4 mb-2">
            <a
              href="https://www.instagram.com/mingleeapp?igsh=bTE0ZXZzdXZwbTls&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="text-custom-red text-2xl" />
            </a>
            <a
              href="https://www.tiktok.com/@mingleewebapp?_t=8r1yyLHHOBM&_r=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTiktok className="text-custom-red text-2xl" />
            </a>
            <a
              href="https://www.linkedin.com/in/mingleewebapp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className="text-custom-red text-2xl" />
            </a>
            <a
              href="https://x.com/mingleewebapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter className="text-custom-red text-2xl" />
            </a>
          </div>
          <p className="text-sm">Minglee Social Ltd © 2024</p>
        </div>

        {/* Navigation Links: Resources and Legal side by side */}
        <div className="flex flex-row space-x-12 justify-center items-center">
          <div className="text-center md:text-left">
            <h3 className="font-semibold">Resources</h3>
            <ul>
              <li>Trust & Safety</li>
              <li>Get in Touch</li>
              <li>FAQ</li>
            </ul>
          </div>
          <div className="text-center md:text-left">
            <h3 className="font-semibold">Legal</h3>
            <ul>
              <li>
                <Link to="/terms-service" className="">
                  Terms Service
                </Link>
              </li>
              <li>Privacy Policy</li>
              <li>Terms of Use</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
